import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { ProductAllowedQuantityRequest } from '../../../../_core/quantiProduct.model';
import { ProductAllowedQuantityAdapter } from './product-allowed-quantity.adapter';

@Injectable({
  providedIn: 'root',
})
export class ProductAllowedQuantityService {
  request$ = new BehaviorSubject<ProductAllowedQuantityRequest>({
    productChanges: [],
  });

  constructor(private productAllowedQuantityAdapter: ProductAllowedQuantityAdapter) {}

  checkProductAllowedQuantity(): Observable<ProductAllowedQuantityRequest> {
    return this.productAllowedQuantityAdapter
      .checkProductAllowedQuantity()
      .pipe(tap(result => this.request$.next(result)));
  }
}
